module.exports = __webpack_public_path__ + "img/login.87accd8c.png";